export default function Exception() {}